import {
  IconCircleCheck,
  IconCircleInfo,
  IconCircleX,
  IconLoadingCircle,
  IconExclamationTriangle,
} from "central-icons";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <IconCircleCheck className="size-4 text-green" />,
        info: <IconCircleInfo className="size-4" />,
        warning: <IconExclamationTriangle className="size-4" />,
        error: <IconCircleX className="size-4 text-destructive-foreground" />,
        loading: <IconLoadingCircle className="size-4 animate-spin" />,
      }}
      theme={theme as ToasterProps["theme"]}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:flex! group-[.toaster]:gap-2! group-[.toaster]:bg-card! group-[.toaster]:text-card-foreground! group-[.toaster]:p-3! group-[.toaster]:border-0! group-[.toaster]:rounded-form-element! group-[.toaster]:shadow-md!",
          icon: "group-[.toast]:m-0!",
          description: "group-[.toast]:text-muted-foreground!",
          actionButton:
            "group-[.toast]:bg-primary! group-[.toast]:text-primary-foreground!",
          cancelButton:
            "group-[.toast]:bg-secondary! group-[.toast]:text-secondary-foreground!",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
